import StyleInput from "../../components/Button/Input";
import StyleSelect from "../../components/Button/AutoComplete";
import tabletrans from "../../translate/tables";
import { useState, useEffect } from "react";
import PostReq from "../../utils/PostReq";
function ShemshFilters(props) {
  const handleFilterChange = (property, value) => {
    let timeout;
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      props.setFilters((prevState) => ({
        ...prevState,
        [property]: value,
      }));
      // Update URL here
      props.updateUrlWithFilters({
        ...props.currentFilters,
        [property]: value,
      });
    }, 3000);
  };

  return (
    <div className="user-filter">
      <div className="serach-input">
        <StyleInput
          title={"از"}
          direction={props.lang.dir}
          action={(e) => handleFilterChange("from", e)}
        />
        <StyleInput
          title={"تا"}
          direction={props.lang.dir}
          action={(e) => handleFilterChange("to", e)}
        />
        <StyleInput
          title={"قیمت"}
          direction={props.lang.dir}
          action={(e) => handleFilterChange("price", e)}
        />
      </div>
    </div>
  );
}
export default ShemshFilters;
